/**********************************************************************************************************************/
/* FILE: hafas_webapp_controller_analysis.js                                                                                */
/**********************************************************************************************************************/
/* Controller.Analysis */

/**
 * @class this.Controller.Analysis
 */
HafasWebapp.prototype.Controller.Analysis = {
  /**
   * @class this.Controller.Analysis.index
   *
   */
  statists: {},
  hciRequests: [],
  keywords: [],
  counter: 1,

  init: function() {
    Hafas.bind(this.Controller.Analysis.clearStatistKeywords, this)();
    Hafas.bind(this.Controller.Analysis.clearStatistList, this)();
    Hafas.Modules.Render.render({
      file    : 'analysis.html',
      target  : 'HFS_StatWrapper',
      template: 'Analysis_TplForm',
      model   : {}
    }, Hafas.bind(function (html) {
    }, this));
  },

  setHCIResponse: function(requestParams, responseParams) {
    // console.log("requestParams", requestParams);
    // console.log("responseParams", responseParams);
    var htmlStatist = "";
    var keywordStr = Hafas.bind(this.Controller.Analysis.getStatistKeywords, this)();
    if(keywordStr == "") {
      Hafas.Util.gui.setVisibility(Hafas("#HFS_StatWarning"), true);
    } else {
      var responseStatist = null;
      Hafas.Util.gui.setVisibility(Hafas("#HFS_StatWarning"), false);

      var id = Hafas.bind(this.Controller.Analysis.createID, this)(JSON.parse(requestParams), responseParams.svcResL[0]);
      var isNewRequest = true;
      for(var i = 0; i < this.Controller.Analysis.hciRequests.length; i++) {
        if(this.Controller.Analysis.hciRequests[i].id == id) {
          isNewRequest = false;
        }
      }
      if(isNewRequest && (id != "")) {
        if(responseParams.svcResL[0].hasOwnProperty('statist')) {
          responseStatist = responseParams.svcResL[0].statist;
          htmlStatist = responseParams.svcResL[0].statist.replace(/\n/g, "<br/>");
          htmlStatist = htmlStatist.replace(/ /g, "&nbsp;");

        this.Controller.Analysis.hciRequests.push(
            {
              service: responseParams.svcResL[0].meth,
              id: id,
              req: requestParams,
              statist: responseStatist,
              htmlStatist: htmlStatist
            }
        );
        }
        Hafas.bind(this.Controller.Analysis.renderHCIResponseStatist, this)();
      }
    }
  },

  createID: function(req, res) {
    // console.log(req);
    // console.log(res);
    var method = res.meth;
    var id = "";
    switch(method) {
      case "TripSearch":
        id = res.id;
        break;
      case "StationBoard":
        id = res.id;
        break;
      case "JourneyDetails":
        id = res.id;
        break;
      case "LocGeoPos":
        id = res.id;
        break;
      case "LocMatch":
        id = req.svcReqL[0].req.input.loc.name + "_" + this.Controller.Analysis.counter;
        this.Controller.Analysis.counter++;
        break;
    }
    return id;
  },

  renderHCIResponseStatist: function() {
    var requestList = this.Controller.Analysis.hciRequests;
    Hafas.Modules.Render.render({
      file    : 'analysis.html',
      target  : 'HFS_StatInfo',
      template: 'Analysis_TplStatTabsNew',
      model   : {reqL: requestList}
    }, Hafas.bind(function (html) {
      Hafas("#HFS_StatWrapper").style.height = window.innerHeight - 50 + "px";
      Hafas.Core.newType('HafasSegmentedControl', {holder: 'HFS_StatInfo'}).initiate();
    }, this));
  },

  clearStatistList: function(e) {
    if(typeof e != "undefined") {
      e.preventDefault();
    }
    this.Controller.Analysis.counter = 1;
    this.Controller.Analysis.hciRequests = [];
    if(Hafas("#HFS_StatInfo")) {
      Hafas("#HFS_StatInfo").innerHTML = "";
    }
  },

  clearStatistResult: function(context, id, e) {
    if(typeof e != "undefined") {
      e.preventDefault();
    }
    var statistL = this.Controller.Analysis.hciRequests;
    for(var i = 0; i < statistL.length; i++) {
      if((statistL[i].service == context) && (statistL[i].id == id)) {
        this.Controller.Analysis.hciRequests.splice(statistL[i], 1);
        break;
      }
    }
    Hafas.bind(this.Controller.Analysis.renderHCIResponseStatist, this)();
  },

  downloadStat: function(context, id) {
    var element = document.createElement('a');
    var date = new Date();
    // var stat = this.Controller.Analysis.instance.getStatist(context)[req].statist;
    var stat = null;
    var statistL = this.Controller.Analysis.hciRequests;
    for(var i = 0; i < statistL.length; i++) {
      if((statistL[i].service == context) && (statistL[i].id == id)) {
        stat = statistL[i].req + statistL[i].statist;
      }
    }

    var dateStr = date.getFullYear().toString() +
        (date.getMonth() + 1).toString() +
        date.getDate().toString() +
        (date.getHours() + 1).toString() +
        date.getMinutes().toString() +
        date.getSeconds().toString();
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(stat));
    element.setAttribute('download', 'Statist_' + context + "_" + id + "_" + dateStr);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  },

  setStatistKeyword: function(checkbox) {
    var keyword = checkbox.value;
    var boolval = checkbox.checked;
    var hasKeyword = false;
    var index = 0;
    for(var i = 0; i < this.Controller.Analysis.keywords.length; i++) {
      if(this.Controller.Analysis.keywords[i] == keyword) {
        hasKeyword = true;
        index = i;
      }
    }
    if(boolval && !hasKeyword) {
      this.Controller.Analysis.keywords.push(keyword);
    } else if(!boolval && hasKeyword) {
      this.Controller.Analysis.keywords.splice(index, 1);
    }
    var keywordStr = Hafas.bind(this.Controller.Analysis.getStatistKeywords, this)();
    // this.Controller.TP.instance.setStatistKeywords(keywordStr);
    this.Controller.Analysis.instance.setStatistKeywords(keywordStr);
  },

  getStatistKeywords: function() {
    var keywords = "";
    for(var i = 0; i < this.Controller.Analysis.keywords.length; i++) {
      keywords += this.Controller.Analysis.keywords[i];
      if(i < (this.Controller.Analysis.keywords.length - 1)) {
        keywords += ",";
      }
    }
    return keywords;
  },

  clearStatistKeywords: function() {
    this.Controller.Analysis.keywords = [];
  }

};